import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViewerService {

    readonly api = 'https://localhost:9000/viewer';

    constructor(private http: HttpClient) {}

    getRegistration(id: string): Observable<RegistrationModel> {
        return this.http.get<RegistrationModel>(`${this.api}/getRegistration`, { params: { id } });
    }

    autoSave(changes: {id: string, json: string}): Observable<boolean> {
        return this.http.patch<boolean>(`${this.api}/autosave`, changes);
    }

    submit(changes: {id: string, json: string}): Observable<boolean> {
        return this.http.patch<boolean>(`${this.api}/submit`, changes);
    }

}

export type RegistrationModel = {
    id : string;
    status : ERegistrationStatus;
    json : string;
    version : {
        id : string;
        json : string;
        form : {
            id : string;
            title : string;
            code : string;
            type : string;
        };
    };
}

export enum ERegistrationStatus {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Complete = 'Complete',
}
